var map = {
	"./p1.png": 588,
	"./p2.png": 9591,
	"./p3.png": 7102,
	"./p4.png": 3841,
	"./p5.png": 9976,
	"./p6.png": 6835,
	"./p7.png": 9082,
	"./p8.png": 6861,
	"./p9.png": 2964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9610;